import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../shared/services';


export const errorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<any> => {
  const authenticationService = inject(AuthenticationService);

  if (request.headers.has('disableInterceptor')) {
    return next(request);
  }

  return next(request).pipe(
    catchError((err) => handleHttpError(err, request, next, authenticationService))
  );
};

const handleHttpError = (
  err: any,
  request: HttpRequest<any>,
  next: HttpHandlerFn,
  authenticationService: AuthenticationService
): Observable<any> => {
  if (err && typeof err !== 'string' && 'status' in err) {
    // We do NOT handle 401 here anymore. JwtInterceptor handles it.
    // If JwtInterceptor fails, the error propagates here, but we should just throw it.
    // Logging out here is aggressive and causes session termination.

    return throwError(
      () =>
        err.error
          ? err.error
          : 'Internal error happened during requesting resource.'
    );
  }

  const error =
    typeof err === 'string'
      ? err
      : err instanceof HttpErrorResponse
        ? `${err.status} ${err.statusText}`
        : 'error' in err
          ? err.error.message
          : 'statusText' in err
            ? err.statusText
            : `${err}`;

  return throwError(() => error);
};
